import { Language } from './../interfaces/language.interface';

export const SUPPORTED_LANGUAGES: Language[] = [
  {
    code: 'de',
    displayName: 'Deutsch',
  },
  {
    code: 'fr',
    displayName: 'Français',
  },
];

export const FALLBACK_LANGUAGE = 'fr';
